<template>
            <div class="small-12 column">
                <p class="text-small">{{'txtUploadFilesQUpload'|translate}}</p>

                <div class="file-list">
                    <div v-for="file in files" class="small-12 column">
                        <PrintFile :filename="file.name" :filestatus="file.status"
                                   :file="file.file" v-on:delete-file="deleteFile"/>
                    </div>
                </div>

                <div @drop.prevent="dragndropFile" @dragover.prevent class="upload__input d-flex flex-column bg-shade-light pt-3 pb-3 px-2 p-4@medium flex-center text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.73 33.62" class="svg-icon upload-icon m-auto svg-icon--xxlarge"><path d="M40.71 14.63c-.37 0-.74.02-1.11.06l-1.24.13.09-1.24c.02-.3.03-.59.03-.87 0-7-5.69-12.7-12.7-12.7-3.21 0-6.28 1.2-8.63 3.38a12.68 12.68 0 00-4.03 8.28l-.09 1.1-1.09-.15c-.46-.06-.93-.09-1.4-.09C4.73 12.53 0 17.26 0 23.07c0 5.78 4.71 10.51 10.49 10.54H23.55V24.5v-.31c-.09.07-.14.11-.18.15-.68.67-1.36 1.34-2.02 2.03-.51.53-1.08.88-1.83.76-.71-.11-1.23-.51-1.48-1.18-.25-.65-.19-1.3.29-1.83.68-.75 1.42-1.46 2.14-2.19 1.18-1.19 2.37-2.37 3.55-3.56.8-.81 1.98-.81 2.67-.13.79.76 1.56 1.53 2.33 2.31l3.06 3.06c.31.3.62.6.77 1.02a1.9 1.9 0 01-.75 2.23c-.72.46-1.7.38-2.32-.23-.67-.65-1.32-1.32-1.98-1.98-.14-.15-.3-.28-.49-.47v9.42h13.45c5.5-.03 9.97-4.29 9.97-9.49 0-5.22-4.49-9.48-10.02-9.48z" fill="#cad505"></path></svg>
                    <label class="label-aligned text-small mt-2">
                        {{'txtUploadArea'|translate}}
                    </label>
                </div>

              <div>
                  <input aria-hidden="true" @change="upload" type="file" :accept="allowedFileExtensions" name="files" ref="uploadfiles" id="fileuploadprintQ"
                         class="upload__file sr-only" data-multiple-caption="{count} files selected" multiple="false">
                  <input type="hidden" name="ajax" value="1">
                  <div class="d-flex flex-column pt-3 flex-center text-center">
                    <input type="button" @click="pickFile" class="btn btn--dark label-aligned m-auto w-auto@large" :disabled="uploadInProgress" :value="'txtUploadPrintFile'|translate"/>
                  </div>
              </div>
            </div>
</template>

<script>
import PrintFile, {FILESTATUS, MAX_FILESIZE} from "components/PrintFile.vue";
import {translatePrj} from "../classes/vue-dict-filter";
import {OVERALLSTATUS} from "../models/enums";

export default {
  components: {PrintFile},
  data() {
    return {
      allowedFileExtensions: ['.pdf'],
    }
  },
  computed: {
    uploadInProgress() {
      return this.printqService.observableData.files.some(file => file.status === FILESTATUS.LOADING)
    },
    files() {
      return this.printqService.observableData.files
    }
  },
  inject: ['printqService', 'configuratorService'],
  methods: {
    pickFile: function() {
      this.$refs.uploadfiles.click();
    },
    dragndropFile: function (e) {
      if (!this.uploadInProgress) {
        this.$refs.uploadfiles.files = e.dataTransfer.files;
        this.upload()
      }
    },
    deleteFile: function () {
      this.printqService.deleteFiles();

    },
            upload: function(){
                if( !this.uploadInProgress ) {

                    let filelist = this.$refs.uploadfiles.files;

                    this.printqService.deleteFiles()

                    let file = filelist[0];
                    let fileObj = this.addFileToList(file);

                    if (!this.isFileExtensionValid(fileObj)){
                        fileObj.status = FILESTATUS.ERROR_FILETYPE;
                        return
                    }
                    if ( file.size > MAX_FILESIZE )
                    {
                        fileObj.status = FILESTATUS.ERROR_FILESIZE;
                        return
                    }

                    this.startPrintQUpload(fileObj)
                }
            },
            addFileToList: function(file) {
                let fileObj = {
                    name: file.name,
                    identifier: "",
                    status:  FILESTATUS.LOADING,
                    file: file
                };
                this.printqService.addfile(fileObj);
                return fileObj;
            },
            isFileExtensionValid: function(file) {
                let lcfilename = file.name.toLowerCase()
                return this.allowedFileExtensions.some(extension=>lcfilename.endsWith(extension))
            },
            startPrintQUpload: function (fileObj) {
              this.printqService.packingAPI.uploadPdf(fileObj.file, {...this.configuratorService.byConfigoptionType("Printq").dynamicValues.conf3DModel})
                  .then(r => {
                    this.printqService.setUploadId(r.id);
                    fileObj.status = FILESTATUS.OK
                    this.configuratorService.validate()
                  })
                  .catch(err => fileObj.status = FILESTATUS.ERROR_FILETYPE)
              this.configuratorService.observableData.data.overallStatus.message = translatePrj('uploadfileUploadInProgress');
              this.configuratorService.observableData.data.overallStatus.status = OVERALLSTATUS.INCOMPLETE;

            },
        },
        mounted() {
        },
    }
</script>
